module.exports = __webpack_public_path__ + "img/swift-icon.a8f87f8c.svg";